'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var asterisk = require('./asterisk-436ee6b3.js');

var StyledLabel = styled__default.label(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font: 14px/22px ", ";\n  color: ", ";\n"], ["\n  font: 14px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var FieldLabel = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, label = _a.label, _b = _a.required, required = _b === void 0 ? false : _b, children = _a.children, readOnly = _a.readOnly, restProps = tslib_es6.__rest(_a, ["dataCy", "dataTestId", "label", "required", "children", "readOnly"]);
    var updatedLabel = readOnly && label ? label + ":" : label;
    return (React__default.createElement(StyledLabel, tslib_es6.__assign({ "data-cy": dataCy, "data-testid": dataTestId, className: "field-label" }, restProps),
        updatedLabel && updatedLabel,
        !readOnly && label && required && React__default.createElement(asterisk.Asterisk, { dataCy: dataCy, dataTestId: dataTestId }),
        children));
};
var templateObject_1;

exports.FieldLabel = FieldLabel;
